<div class="filter-for-list">
  <h4> {{'OMP_MANUAL'|translate}}</h4>
</div>
<mat-vertical-stepper>

  <!-- <mat-step>

       <ng-template matStepLabel>Table des matières</ng-template>
       <mat-horizontal-stepper>
           <mat-step>

               <ng-template matStepLabel>Démarrer</ng-template>

               <a href="">Login</a> <br>
               <a href="">Tableau de bord</a> <br>
               <a href="">Description du tableau de bord</a> <br>
               <a href="">Changer la langue</a> <br>
               <a href="">Gérer son compte OSMOS</a> <br>
               <a href="">Accéder aux Niveaux, Utilisateurs, Projets, Equipements</a>


           </mat-step>
           <mat-step>

               <ng-template matStepLabel>Gestion des Niveaux</ng-template>
               <a href="">Effectuer une recherche parmi les niveaux</a> <br>
               <a href="">Afficher tous les niveaux/uniquement les niveaux disponibles</a> <br>
               <a href="">Ajouter un niveau</a> <br>
               <a href="">Afficher/Editer un niveau</a>


           </mat-step>
           <mat-step>

               <ng-template matStepLabel>Gestion des utilisateurs</ng-template>
               <a href="">Rôle des utilisateurs</a> <br>
               <a href="">Rechercher un utilisateur</a> <br>
               <a href="">Afficher uniquement les utilisateurs disposant d'un rôle spécifique</a> <br>
               <a href="">Ajouter un utilisateur</a><br>
               <a href="">Afficher/Editer/réinitialiser un utilisateur</a>

           </mat-step>
           <mat-step>

               <ng-template matStepLabel>Gestion des projets</ng-template>
               <a href="">Rechercher un projet</a> <br>
               <a href="">Afficher les projets actifs/inactifs</a> <br>
               <a href="">Ajouter un projet</a> <br>
               <a href="">Utiliser les boutons projet</a><br>
               <a href="">Gérer les alarmes</a><br>
               <a href="">Graphe</a>

           </mat-step>
           <mat-step>
               <ng-template matStepLabel>Gestion des équipements</ng-template>
               <a href="">Types d'équipements</a> <br>
               <a href="">Rechercher un équipement</a> <br>
               <a href="">Filtrer les équipements indisponibles/inactifs</a> <br>
               <a href="">Ajouter un équipement</a><br>
               <a href="">Transférer des équipements vers un niveau</a>

           </mat-step>
           <mat-step>
               <ng-template matStepLabel>Option Maths</ng-template>
               <a routerLink="" fragment="maths">Option Maths</a> <br>
           </mat-step>
       </mat-horizontal-stepper>


   </mat-step> -->

  <mat-step>

    <ng-template matStepLabel>Get started with OSMOS Project Manager</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Login</ng-template>
        <p class="texte">
          Browser: preferably use Google Chrome<br>
          In your browser fill in the following address:<a
          routerLink="/login">https://store.osmos-group.com/login</a><br>
          Fill in your username and password then, click on "Login".<br>
          <img src="assets/images/noticeOPM/img1.png" alt="Login"> <br>
          If you have forgotten your password, click on "Forgot Password?", Then fill in your
          e-mail address and click "Send".
        </p>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Dashboard</ng-template>
        <p class="texte">
          Once logged in, you land on the home page or "Dashboard" which allows you to have
          a view of all your levels, devices and users as well as their different
          projects and various statistics.
          You can manage users, their access levels, their projects and their devices
          through the top menu (top banner) that will allow you to access the corresponding page.
          <br>
          <img src="assets/images/noticeOPM/tableaudebord1.png" style="width: 750px" alt="Login"><br> <br>
          Dashboard description : <br>
          <img src="assets/images/noticeOPM/dashboard.png" alt="Login"><br></p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Language</ng-template>
        <p class="texte">
          Switch from French to English by clicking this button:<br>
          <img src="assets/images/noticeOPM/eng4.png" alt="Login">
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Level change</ng-template>
        <p class="texte">Change level easily using this button:<br>
          <img src="assets/images/noticeOPM/niveau1.png" style="width: 750px" alt="Login">
        <p>Selected level is locally saved</p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Manage your account</ng-template>
        <p class="texte">
          To manage your OSMOS account, click on "My Account" in the headband: <br>
          <img src="assets/images/noticeOPM/eng6.png" alt="Login" style="width: 750px"> <br>
          You then have access to all the information about your account and the Level that is linked to it.
          <br>Press the "pencil" button to edit this information <br>
          <img src="assets/images/noticeOPM/eng7.png" alt="Login" style="width: 750px"></p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>EDAS connection</ng-template>
        <br>
        OPM users can check the connectivity of their EDAS stations by clicking this button :<br>
        <img src="assets/images/noticeOPM/stations.png" alt="Login"> <br>
        Upon clicking the "eye" button, EDAS details will be shown. You can also directly click the link toward the
        EDAS.
        <img src="assets/images/noticeOPM/stations2.png"> <br>

        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Access Levels, Users, Projects, Devices,Special, SAFE Manager</ng-template>
        Navigate to the Levels, Users, Projects and Devices pages with these six buttons:<br>
        <img src="assets/images/noticeOPM/eng8.png" alt="Login">
        <div>
          <div>
            <button mat-button matStepperPrevious>Back</button>
          </div>
        </div>
      </mat-step>


    </mat-horizontal-stepper>

  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Manage Levels</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Level search</ng-template>
        <p class="texte">Fill in this field to search through the levels:<br>
          <img src="assets/images/noticeOPM/eng9.png" alt="niveau"></p>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Show All Levels / Only Active Levels</ng-template>
        <p class="texte">Just click this button : <br>
          <img src="assets/images/noticeOPM/eng10.png" alt="niveau"></p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Add Level</ng-template>
        <p class="texte">First click this button:<br>
          <img src="assets/images/noticeOPM/eng11.png"><br>
          A popup window is displayed:<br>
          <img src="assets/images/noticeOPM/eng12.png"><br>
          Fill in your Name, Email and Language here, select if the level is active or not, then click on "
          Following ". You then go to the next step: <br> <br>
          <img src="assets/images/noticeOPM/eng13.png"><br>
          You can fill in the address, zip code, city, country and add notes for
          this level. Then click on "Next", or Back if you want to change the information
          previously informed. You then go to the verification and backup step: <br>
          <img src="assets/images/noticeOPM/eng14.png"><br>
          Check the completed fields and click on "Back" to modify them. If they are all correct,
          then click on "Save" to save the new level create. The level then appears in the list of Levels
          :<br>
          <img src="assets/images/noticeOPM/eng15.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>View / Edit Level</ng-template>
        <p class="texte">

          At any time you can consult the information of the level as well as edit them by clicking
          respectively on the eye button or the pencil button corresponding to the selected level:
          <img src="assets/images/noticeOPM/img12.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>

    </mat-horizontal-stepper>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Manage Users</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Users Roles</ng-template>
        <p class="texte">
          There are 10 roles that give different access to the features of the site. Each user has
          at least one role and can have as much as necessary. <br>
          Roles are : <br>
        <ul>
          <li>User : access to OSMOS Project Manager</li>
          <li>Client : access to Safe WORK for linked project(s)</li>
          <li>Installer : required in order to install specific devices</li>
          <li>Level Admin : allow creation and edition of users for this level</li>
          <li>Engineer : gives access to Safe ANALYZER for linked projects)</li>
          <li>Production : gives access to the Devices tab for reading and writing</li>
          <li>Data Scientist : User role + access to the Maths tab</li>
          <li>All Levels for SAFE :gives all rights and access to SAFE</li>
          <li>Business: User & client role</li>
          <li>Contact : access to alarms</li>
        </ul>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Searching for an User</ng-template>
        <p class="texte">
          Use the following search field : <br>
          <img src="assets/images/noticeOPM/eng17.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Displaying a specific role</ng-template>
        <p class="texte">
          To display only users with at least one particular role, click the
          role you want to display among the following options:<br>
          <img src="assets/images/noticeOPM/eng18.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Adding an User</ng-template>
        <p class="texte">
          To add an User, first click on this button at the top of the page: <br>
          <img src="assets/images/noticeOPM/eng19.png"><br>
          The following pop-up opens up : <br>
          <img src="assets/images/noticeOPM/eng20.png"><br>
          Fill in the necessary information: Name, Surname, Email, Language and if
          the user is active or not (phone is optional). Then click on next, you find the next pop-up : <br>
          <img src="assets/images/noticeOPM/eng21.png"><br>
          Then check all the roles you want to assign to the new User. At least one role
          to be selected. Validate by clicking on next. <br>
          A third pop-up then opens: <br>
          <img src="assets/images/noticeOPM/eng22.png"><br>
          Choose a password and click Next.
          A pop-up containing the information entered is displayed:<br>
          <img src="assets/images/noticeOPM/eng23.png"><br>
          Check your information: modify them by clicking on "Back", or save them by clicking
          on "Save". Once the backup is done, the newly created user appears in
          the list of users: <br>
          <img src="assets/images/noticeOPM/eng24.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>View / Edit / Reset an User</ng-template>
        <p>
          You can at any time view the information related to the User by pressing the
          "eye" button in front of the desired user. You can also edit a user in
          pressing the "pencil" button. Finally using the "key" button, you can sen+d a
          password reset email to the User. <br>
          <img src="assets/images/noticeOPM/img23.png"><br>

        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>


  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Manage Projects</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Finding a Project</ng-template>
        <p class="texte">
          To search for a project, use the following button: <br>
          <img src="assets/images/noticeOPM/eng26.png"><br>
          To change the view between active and inactive projects, click this button: <br>
          <img src="assets/images/noticeOPM/eng27.png"><br>
        </p>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Adding a Project</ng-template>
        <p class="texte">
          To add a project, first click on the following button:<br>
          <img src="assets/images/noticeOPM/eng28.png"><br>
          It opens the first step : <br>
          <img src="assets/images/noticeOPM/eng29.png"><br>
          Fill in the project start date, the end date, the project name, its code and a
          project description. Validate by clicking on "next". <br> The following step appears: <br>
          <img src="assets/images/noticeOPM/eng30.png"><br>
          You must then fill in the address of the project. To do this, two options are possible: <br>
          1) Place the project directly on the map. The address will be filled automatically on the
          form. Note that a satellite view and a "plan" view are available. <br>
          2) Fill in the address directly in the form. The point on the map will update
          automatically. <br>
          You can then fill in the Notes field. Then click on "Accept" to validate
          the address. You can reset the map and the form at any time by clicking on the
          "Reset" button. <br> <br>
          Once the address is completed and accepted, click on the "next" button at the bottom left of
          your screen. <br>
          A summary of the information entered appears: <br>
          <img src="assets/images/noticeOPM/eng31.png"><br>
          Check the information related to the project and click on "save" if they are correct, otherwise
          change them by pressing "Back".<br>
          <br>
          After pressing the save button, three new steps that you can configure appear: <br>
          4-Users <br> 5-Devices <br> 6-Locations <br>
          <img src="assets/images/noticeOPM/eng32.png"><br>
          Add a user with the "Add a User" button. Delete it with thanks to the red cross in front of the user.
          Designate the main client with the "main client" button
          . Click Next to go to the Device step. <br>
          <img src="assets/images/noticeOPM/eng33.png"><br>
          At this stage you can add devices to your project thanks to the button "Add Devices". You can then
          edit the added device by clicking on the device, and chose to automatically create associated locations or
          not.
          Confirm by pressing the green button. Edit the project ID by clicking on it.
          Delete a device by clicking on the red cross. You can also enable / disable the
          editor mode by clicking on the padlock. Then click on Next to go to step "
          Location ». <br>
          <img src="assets/images/noticeOPM/eng34.png"><br>
          Fill in the "name" field (and parent if applicable) and click on "Add location".
          It will appear in the list of locations. You can change it with the button
          validation, add a piece of device thanks to the "assign device" button, the
          delete with the red "cross" button. A location can no longer be deleted once a
          device is assigned to it <br> You have the possibility to lock / unlock the editor mode
          thanks to the "padlock" button. <br> Your project will appear in the list of projects: <br>
          <img src="assets/images/noticeOPM/img33.png"><br>
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Project Buttons</ng-template>
        <p class="texte">
          <img src="assets/images/noticeOPM/img34.png"><br>
          1) Eye button: provides access to summary information related to the project. <br>
          2) Pencil button: allows you to edit the information related to the project. <br>
          3) Bell button : allows you to view, edit, create and delete alarms for this project <br>
          4) Excel button: opens the export window for sensor measurements <br>
          5) Graph button: allows you to view the graph of the sensor measurements <br>
          6) Project last measure : Click here to view last measures' dates
        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Manage Alarms</ng-template>
        <p class="texte">
          After clicking on the orange "alarm" button, the following page opens: <br>
          <img src="assets/images/noticeOPM/eng36.png"><br>
          Find an alarm thanks to the "search" field, the button filtering the active / inactive alarms
          or by selecting the type of alarm (location, threshold, ...,) at the top of the page: <br>
          <img src="assets/images/noticeOPM/eng37.png"><br>
          Add an alarm by clicking on "add an alarm", the following popup will open:<br>
          <img src="assets/images/noticeOPM/eng38.png"><br>
          Choose the type of alarm and name it. Then press next to go to the next
          step: <br>
          <img src="assets/images/noticeOPM/eng39.png"><br>
          Here you must assign a priority to your alarm. Click Next to go to the next step
          <br>
          <img src="assets/images/noticeOPM/eng40.png"><br>
          The alarm must be assigned to one or more locations. Click on "+ Add location", select the locations
          affected by the alarm then confirm by clicking on
          "Next". The next step appears :<br>
          <img src="assets/images/noticeOPM/vocalalarm.png"><br>
          This step is used to designate users who will be notified by the alarm. Click on "add
          user" to subscribe one or more users to this alarm. Then determine how
          users will be notified in case of alarm triggering: via SMS, email, or voice call. Validate by clicking on
          next.
          <br>The summary step is then displayed :<br>
          <img src="assets/images/noticeOPM/eng42.png"><br>
          Check the information entered and click on "Save". The alarm then appears in
          the list. <br>
          Note that not all steps are accessible for each alarm type. <br><br>
        <h4>Operating Alarm</h4>
        OPM users can set up an Operating Alarm on one or more locations to
        control data's reception and its relevance. It must be assigned to one, several,
        or all locations with the following tab:<br>
        <img src="assets/images/noticeOPM/imgoperatingalarm.png"><br>
        <h4>Combination Alarm:</h4><br>

        OPM Users are able to create a combination alarm by using the “add alarm” button on the project alarm page
        and selecting the “combination-alarm” chip. OPM Users must first enter the alarm name. Then OPM has to build
        alarm expression: <br><br>

        Alarm1 [operator: and/or/xor] Alarm2 [and/or/xor] Alarm3 [and/or/xor] … <br><br>

        Users can build the expression by clicking on alarms and operators chips or by directly writing in the
        expression (with auto-completion). <br>

        A message must be added : <br><br>
        <img src="assets/images/noticeOPM/combinationalarm.png">

        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Using the Graph</ng-template>
        <p class="texte">Once the graph button is clicked, the following page will appear : <br><br>
          <img src="assets/images/noticeOPM/graph1.png" style="width: 700px;"><br>
          Fill in the desired parameters for the display of the graph in the first red rectangle
          and the desired locations in the second. <br>
          You can also change the time by clicking on the framed clock button:<br>
          <img src="assets/images/noticeOPM/enggraph0.png"><br>
          <br>New graph features : <br> <br>
          <img src="assets/images/noticeOPM/eng44.png"><br>
          New features are circled in red: <br> <br>
          The "axis view" button, surrounded in green in the first red frame, allows to show / hide
          the
          view of the axes, shown here in the rightmost red rectangle. In this context it is then
          possible
          to show / hide each of the four axes, to display them to the left or right of the graph,
          or
          yet to assign them a maximum or minimum limit. <br>
          The last red frame changes the type of chart. By default it is a graph in
          line,
          but you can display a chart in areas, in columns, a graph "spline" and a
          graph in
          spline areas. You can also choose to see a "stepped" curve. <br>
          Finally, it is possible to group data by period of 1 to 12 hours / days / weeks / months
           </p><br>
        Each of your actions (up to the last 20) are recorded in your local storage, it is
        thus possible to cancel or restore your actions by clicking on the 'previous' or 'next' arrows located
        next to the view name.
        <br><br>
        <p> It is also possible to reorganize the location tree. To do so, click on the following button: <br> <img
          src="assets/images/noticeOPM/dragDropAccess.png"> <br></p>
        After a confirmation window, the drag & drop modal is displayed: <br> <img
        src="assets/images/noticeOPM/dragDropModale.png" style="height: 500px"> <br>
        You can then simply reorganize your locations and groups by means of a drag and drop. The interface also allows
        you to create a new group, or delete an empty group.
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Offset, Eraser</ng-template>
        To use the Offset option first click on this icon: <br>
        <img src="assets/images/noticeOPM/graph3.png"> <br>
        To use the data eraser click on this icon: <br>
        <img src="assets/images/noticeOPM/graph2.png"> <br>
        Then use the tabs to navigate between Offset and Data Eraser:
        <br><img src="assets/images/noticeOPM/offseroreraser.png"><br>
        Simple Offset: First select the relevant sensors. Determine an Offset value, activate if necessary the offset on
        future
        or past measurements via the toggle button and then the date.
        Press the OK button : the offset table and the graph will update accordingly <br>
        SmartOffsetMode : If the user is not in thermally compensated data, graph's time range is less than 24h or if
        then number of points in graph is under 140, the
        smart offset mode toggle can be activated: <img src="assets/images/noticeOPM/som.png"><br>. Flags will then
        appear on the graph with a value equal to the
        difference between this point and the previous one. Clicking flags will open the offset modal with value, data
        and
        location already filled. Smart offset mode can be exited by clicking the toggle off<br>
        Data eraser: Determine the start date and the end date as well as the sensors affected by the
        data that you want to override on the graph. Validate in order to update the
        data deletions table as well as the graph.<br>
        Threshold: Select a start date, an end date and the value of the threshold linked to the location to display it
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>View saving</ng-template>
        You can at any time decide to save the parameters and the graph view. To do this, click on the button: <img
        src="assets/images/noticeOPM/saveView01.png" alt="save view" style="width: 400px"><br>
        It is possible to rate the view as "favorite" in order to make it appear first in the list of views.
        The following button gives access to the list of views: <img src="assets/images/noticeOPM/saveView02.png"
                                                                     alt="save view" style="width: 400px"><br> On the
        interface of view list, it is possible to access or delete the view: <br> <img
        src="assets/images/noticeOPM/saveView03.png" alt="save view" style="width: 800px"> < br>
        When a current view is modified, it is possible to update these modifications or to clone a new view from it by
        clicking on the save view button. <br>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Export Data</ng-template>
        To open the window for exporting data in CSV format, click this button
        located at the top right of the graph page: <img src="assets/images/noticeOPM/exp1.png"><br>
        the following page is displayed <br><br>
        <img src="assets/images/noticeOPM/eng46.png" alt="export CSV" style="width:1000px"><br>
        <p style="text-underline: #333333">Then fill in the following parameters: <br></p>
        -Start date <br>
        -End date<br>
        -Types of measures <br>
        -Data from the SMS module <br>
        -Types of data <br>
        -Types of units <br>
        -Devices whose data must be exported <br> <br>

        1st Option - fast export (light data): <br>

        Once the export parameters have been determined, if you wish to start a fast export for your light data, click :
        <img src="assets/images/noticeOPM/eng47.png" alt="export CSV"><br>

        2nd Option - Export planning (big data) <br>
        - The button 'Schedule an export': <img src="assets/images/noticeOPM/plannifExport.png"><br> allows to launch a
        massive export of data. The user is notified by email of
        the start of data export, then when the operation is completed. Users can find the status of their current or
        completed exports by clicking on 'export job tasks status' : <img
        src="assets/images/noticeOPM/exportlist.png"><br>
        On the export status page, Users can download their exports, cancel or delete it, or obtain more information
        about a completed export or one still in progress. Users can also follow the progress of their exports in real
        time.
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>

      </mat-step>
    </mat-horizontal-stepper>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel>Manage Devices</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Device Types</ng-template>
        The available devices are : <br>
        Liris V2 <br>
        Optical<br>
        External<br>
        Temperature<br>
        Inclino V2<br>
        Liris V3<br>
        Inclino V3<br>
        Gateway<br>
        SPCU<br>
        DAU<br>
        Extenso V3<br>
        Incli-bi V2<br>
        v_sensor<br>
        G_sensor<br>
        Liris 420 v3
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Search / Filter devices, Device-Finder</ng-template>
        <p class="texte">
          To search for devices in the list, use the field below.<br>
          <img src="assets/images/noticeOPM/eng48.png"><br>
          The buttons below are used to filter active / inactive devices :<br>
          <img src="assets/images/noticeOPM/eng49.png"><br>
          To see only one type of devices from Liris V2, Optical, External, Temperature, Inclino
          V2, Liris V3, Inclino V3, Gateway, SPCU, DAU, V3 Extenso, Incli-bi V2, <br> click on the
          type wanted here: <br>
          <img src="assets/images/noticeOPM/eng50.png"><br>
          Users with production roles have access to the device-finder modal. Simply enter device's UID to find it no
          matter in what level it is registered by clicking : <br>
          <img src="assets/images/noticeOPM/deviceFinder.png"><br>

        </p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Add Device</ng-template>
        To add a device, first click this button:<br>
        <img src="assets/images/noticeOPM/eng51.png"><br>
        The following pop-up is displayed :<br>
        <img src="assets/images/noticeOPM/eng52.png"><br>
        Then choose the type of device to add, its ID, its length (in case the device has
        one) and its status (Active / Inactive). <br>
        Confirm by clicking Next. A second popup is displayed: <br>
        <img src="assets/images/noticeOPM/eng53.png"><br>
        Enter the parameters A, B, C and the trigger of the device. Validate to access
        recap popup: <br>
        <img src="assets/images/noticeOPM/eng54.png"><br>
        Press "Back" if you have any changes to make. Otherwise, click on "Save". <br>
        new devices will appear in the device list.
        To view or edit a device, use the "eye" and "pencil" buttons respectively
        located in front of the device to display or edit: <br>
        <img src="assets/images/noticeOPM/img49.png"><br>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>

        <ng-template matStepLabel>Virtual Sensor</ng-template>
        OPM Users are able to create v-sensor equipment by setting an ID and a unit. Upon save, the newly created
        v-sensor will be listed among other equipment. Parameters cannot be configured until v-sensor has been saved
        into equipment list and has been assigned to a location. OPM Users can view the information linked
        to a v-sensor by clicking on the “eye” button. By clicking the “pencil” button, OPM Users are allowed to
        edit v-sensor’s information such as it’s ID, it’s unit, and, if it has already been assigned to a location,
        it’s parameters. Parameters to be entered must be of the form "Constant + [A x (Sensor_A1^a1) x
        (Sensor_A2^a2)] + [B x (Sensor_B1^b1) x (Sensor_B2^b2)] + …”
        Upon saving, newly modified parameters will be updated in the store
        <img src="assets/images/noticeOPM/v_sensor_img.png">
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Batch equipment import</ng-template>
        It is possible to import several devices of the same type at a time. To do so, please first
        click on the CSV imports button:
        <img src="assets/images/noticeOPM/equipementloten.png"><br>
        Then opens the following interface: <br>
        <img src="assets/images/noticeOPM/interfaceloten.png"><br>
        Then select the template corresponding to the type of equipment you want to import. A csv file
        will be downloaded. Open it and fill it. Be careful if the UID starts with one or more 0, it is
        need to change the cell format to "text" so that they are not automatically deleted.
        Some parameters are mandatory, others are optional depending on the type of equipment you want
        to integrate. <br>
        Once the file is complete, select it via "choose a file" and click on the "save" button
        If the file is properly filled your equipment will be imported, otherwise an error message will tell you
        precisely where are the errors.
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Transfer devices to another level</ng-template>
        The shopping cart button allows you to move one or more devices to another Level. It appears
        when the filter option: <img src="assets/images/noticeOPM/eng55.png"> is disabled as such : <img
        src="assets/images/noticeOPM/eng56.png"><br>
        We find it here (circled in red): <br>
        <img src="assets/images/noticeOPM/eng57.png"><br>
        First select one or more devices with the boxes circled in green. Then click on the cart to see the
        following popup:
        <img src="assets/images/noticeOPM/eng58.png"><br>
        Then choose a level and click on move. Your device is then reallocated to the selected level.
        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel id="maths">Subscriptions</ng-template>
    <mat-horizontal-stepper>
      <mat-step>
        <ng-template matStepLabel>Thermal correction</ng-template>
        <p>
          Some users have access to the Maths option(those with the role "data scientist"): <br>
          <img src="assets/images/noticeOPM/engautomaticreport0.png"><br>
          This page allows the subscription to the Maths module for a project (thermal correction subscription): <br>
          <br>
          First find the project in question using the search tool and the active / inactive project filter: <br>
          <img src="assets/images/noticeOPM/eng60.png"><br>
          Click this button to access the subscription popup: <br>
          <img src="assets/images/noticeOPM/eng61.png"><br>
          You must then enter the start and end dates of the subscription: <br>
          <img src="assets/images/noticeOPM/eng62.png"><br>
          Then fill in the necessary fields if the static option is activated: <br>
          <img src="assets/images/noticeOPM/engstatic.png"><br>
          Finally you must fill in the required fields if the dynamic option is activated: <br>
          <img src="assets/images/noticeOPM/eng64.png"><br>
          Check the information entered, then click save at the bottom of the summary popup: <br>
          <img src="assets/images/noticeOPM/eng65.png"><br>
          The project is now subscribed to the Maths module
        </p>
        <div>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Automatic report (beta, under development)</ng-template>
        <p class="text"> Go to the automatic report tab: <br>
          <img src="assets/images/noticeOPM/engautomaticreport1.png"> <br>
          Create an automatic report using the form: <br>
          <img src="assets/images/noticeOPM/autoreport0.png"> <br>
          Upload via JSON file for automatic report creation: <br>
          <img src="assets/images/noticeOPM/autoreport1.png"> <br>
          Download the automatic report in JSON format after creation: <br>
          <img src="assets/images/noticeOPM/autoreport3.png"> <br></p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Dynamic Events statistics</ng-template>
        <p>Users can subscribe a project to the Dynamic Events statistics by clicking the "+" button in front of the desired project.</p><br>
        <p>This will enable the "EventDyn" tab on SAFE for this project.</p>
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>

      <mat-step>
        <ng-template matStepLabel>Senceive</ng-template>
        Subscription of a project to SENCEIVE data: <br>
        After selecting the "SENCEIVE" token in the header menu, under the "special" tab, click on the "+" button in
        front of the
        project that you want to subscribe to SENCEIVE data. <br> The following window will appear:
        <img src="assets/images/noticeOPM/special1.png"><br>
        Then simply enter the SENCEIVE project id, the senceive User and the associated password. Check and
        save: the project is therefore subscribed to senceive data.
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>CSV-SFTP</ng-template>
        Automatic export of CSV data to SFTPs:
        After selecting the CSV-SFTP token from the header menu, just click the "+" button in front of the
        concerned project <br> The following window appears:
        <img src="assets/images/noticeOPM/special2.png"><br>
        First, specify whether or not the export should generate static, dynamic, real-time files.
        Then enter the SFTP server, its port, its User and its password. Finally, decide whether or not to keep
        the data in base. You can then save: the automatic export is then programmed.
        <div>
          <button mat-button matStepperPrevious>Back</button>
          <button mat-button matStepperNext>Next</button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>NEWSTEO</ng-template>

        Subscription of projects to NEWSTEO data: <br>
        After selecting the "NEWSTEO" token in the header menu, simply click on the "+" button in front of the
        project that you want to subscribe to NEWSTEO data. <br> The following window appears:
        <img src="assets/images/noticeOPM/special3.png"><br>

        Then simply enter the NEWSTEO project id then save: the project is now subscribed to the NEWSTEO data

        <div>
          <button mat-button matStepperPrevious>Back</button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>

  </mat-step>
</mat-vertical-stepper>


